import moment from 'moment';
import 'moment/locale/ko';
import React from 'react';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import { DevicePathLogType } from '../../controller/DetectorController';
import '../../styles/CustomModal.css';
import DateTab from '../DateTab';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  pathLogData: DevicePathLogType[];
  orderId: string;
  storeName: string;
};

type Params = 'POS_print' | 'POS_delivery' | 'POS_event' | 'POS_click';

type ParamsType = {
  params: Params;
  path_url: string;
  title: string;
};

const ParamItems: ParamsType[] = [
  {
    params: 'POS_print',
    path_url: `${process.env.PUBLIC_URL}/svg/status_coupon.svg`,
    title: '프린트 출력',
  },

  {
    params: 'POS_delivery',
    path_url: `${process.env.PUBLIC_URL}/svg/status_cart.svg`,
    title: '배달 관련',
  },
  {
    params: 'POS_event',
    path_url: `${process.env.PUBLIC_URL}/svg/status_event.svg`,
    title: '이벤트',
  },

  {
    params: 'POS_click',
    path_url: `${process.env.PUBLIC_URL}/svg/status_click.svg`,
    title: '버튼 클릭',
  },
];

const OrderLogModal = ({ isVisible, setVisible, pathLogData, orderId, storeName }: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };

  const getStatusComment = (params: string) => {
    const paramState = ParamItems.find((item) => item.params === params);

    return (
      paramState && (
        <div className="row">
          {paramState.path_url.length > 0 && (
            <img src={paramState.path_url} alt="action_icon" width={16} />
          )}
          <p>{paramState.title}</p>
        </div>
      )
    );
  };

  const getStatusDetail = (params: string, params2: string) => {
    return params + params2.replace(orderId, '');
  };

  return (
    <Style>
      {isVisible && (
        <div className="modalWrap">
          <div className="modalBackground" onClick={onCloseModal}></div>
          <div className="modal">
            <div className="content">
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                alt="닫기"
                width={28}
                className="modalCloseButton"
                onClick={onCloseModal}
              />
              <h2>매장이름: {storeName}</h2>
              <h2>주문번호: {orderId}</h2>

              <div className="title">
                <h2 className="room">TokenId</h2>
                <h2 className="date">날짜</h2>
                <h2 className="action">분류</h2>
                <h2 className="detail">상세내역</h2>
              </div>
              <div className="contentWrap">
                {pathLogData && pathLogData.length > 0 ? (
                  pathLogData.map((data, index) => {
                    return (
                      <div className="modalContent" key={index}>
                        <p className="room">{data.user_token_id}</p>
                        <p className="date">
                          {moment(data.created_at).format('YYYY/MM/DD HH:mm:ss')}
                        </p>
                        <p className="action">{getStatusComment(data.action_name)}</p>
                        <p className="detail">{getStatusDetail(data.params, data.params2)}</p>
                      </div>
                    );
                  })
                ) : (
                  <h2 className="noneList">클릭 내역 없음</h2>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default OrderLogModal;

const Style = styled.div`
  h2 {
    font-size: 14px !important;
    line-height: 20px;
    font-weight: 500;
    color: #555;
  }
  p {
    margin: 10px 0;
    font-size: 12px;
  }

  .content {
    width: 70%;
    padding: 2%;
    z-index: 9999;
    text-align: left;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: relative;
  }
  .modalCloseButton {
    position: absolute;
    top: 3%;
    right: 2%;
    cursor: pointer;
  }

  .row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .title,
  .modalContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    margin-top: 24px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ddd;
  }
  .contentWrap {
    min-height: 30vh;
    max-height: 50vh;
    overflow-y: auto;
  }
  .modalContent {
    border-bottom: 1px solid #eee;
  }
  .room {
    flex: 0 0 10%;
  }
  .date {
    flex: 0 0 20%;
  }
  .action {
    flex: 0 0 25%;
  }
  .detail {
    flex: 0 0 30%;
    white-space: pre-line;
  }
  .noneList {
    margin: 50px 0;
  }

  /* 객실 세부 설정 */
  .toggleWrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .memoWrap {
    margin-bottom: 20px;
    padding: 12px;
    background: #f6f6f6;
    border: 1px solid #eee;
    border-radius: 4px;
    height: 130px;
  }
  .memoWrap.disabled {
    background: #ccc;

    textarea {
      background: #ccc;
      border: 1px solid #bbb;
      outline: none;
      cursor: not-allowed;
    }
    .toggleWrap button {
      cursor: not-allowed;
    }
  }
  .memoTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 4px;
    border-bottom: 1px solid #ccc;

    h3 {
      color: #777;
    }
    button {
      background: #000;
      color: #fff;
      border: none;
      padding: 2px 10px;
      font-size: 14px;
      line-height: 20px;
      border-radius: 4px;
      font-weight: 500;
    }
  }
  .memoContent {
    width: 100%;
    max-width: 100%;
    height: 75%;
    padding: 4px 6px;
    margin-top: 4px;
    word-break: break-word;
    font-size: 14px;
    line-height: 18px;
    border: none;
    border-radius: 4px;
  }

  /* 스크롤바 */
  .contentWrap::-webkit-scrollbar {
    width: 4px;
    background-color: #d1d1d1;
    border-radius: 50px;
  }
  .contentWrap::-webkit-scrollbar-thumb {
    width: 4px;
    background-color: #000;
    border-radius: 50px;
  }

  @media (max-width: 900px) {
    .content {
      width: 90%;
      padding: 4%;
    }
  }
  @media (max-width: 500px) {
    .memoWrap {
      height: 160px;
    }
    .toggleWrap {
      flex-direction: column;
      gap: 0;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
`;
